export default {
  email: 'Введите корректный адрес электронной почты',
  tel: 'Введите корректный номер телефона',
  site: 'Введите корректный адрес сайта',
  bsoSeries: 'Неверный формат серии бланка',
  bsoNumber: 'Неверный формат номера бланка',
  required: 'Поле обязательно',
  minLength: 'Недостаточно символов',
  maxLength: 'Превышена мсаксимальная длина строки',
  previousRequest: 'Введите корректный номер предыдущего обращения',
  excludesRegions:
    'К сожалению, вакансия страхового агента в регионе отсутствует',
  excludesOffices:
    'К сожалению, вакансия страхового агента в офисе отсутствует',
  officeWork: 'В выбранный офис нельзя подать заявку',
  address: 'Введите адрес',
  file: 'Ошибка в загрузке файла, превышен максимальный размер файла в 15 мегабайт. Если это картинка, попробуйте сжать ее.',
  fileAccept:
    'Ошибка в загрузке файла, добавлен недопустимый формат файла. Доступные форматы - ',
  files:
    'Ошибка в загрузке файлов, суммарный размер файлов не должен превышать 20 мегабайт.',
  region: 'Выбранное значение не является регионом',
  city: 'Выбранное значениене не является городом',
  street: 'Укажите название улицы (или квартала итп.)',
  house: 'Укажите номер дома (и квартиры для многоквартирных)',
  district: 'Выбранное значение не является районом',
  userCountSymbols: 'Поле должно содержать минимум 3 символа',
  userName: 'ФИО не должно содержать цифры и спец.символы',
  fullName: 'Введите ФИО полностью',
  simpleName: 'Введите фамилию и имя',
  fullEpamName: 'Введите полное ФИО кирилицей',
  nameCapitalized: 'Укажите имя в нижнем регистре с заглавной буквы',
  surnameCapitalized: 'Укажите фамилию в нижнем регистре с заглавной буквы',
  patronymicCapitalized: 'Укажите отчество в нижнем регистре с заглавной буквы',
  dateDDmmYYYY: 'Заполните дату в формате ДД.ММ.ГГГГ',
  dateYYYYmmDD: 'Заполните дату в формате ГГГГ-ММ-ДД',
  innLength: 'Введите корректный ИНН',
  dateBiggerText: 'Введите корректную дату',
  cyrillic: 'Строка должна содержать только кириллицу',
  cyrillicNew: 'Может содержать только кириллицу',
  dateAndTime: {
    syntax: 'Заполните дату в формате ДД.ММ.ГГГГ',
    max: 'Введенная дата больше текущей',
    min: 'Введенная дата меньше 1900г',
  },
  phoneVerify: 'Необходимо подтвердить номер телефона',
  maxFileSize: (size) => `Размер файла не должен превышать ${size}Мб`,
  maxFilesSize: (size) => `Общий размер фалов не должен превышать ${size}Мб`,
  maxFileSizeGroup: 'Превышен общий размер загруженных файлов',
  maxFileCountGroup: 'Превышено допустимое количество загружаемых файлов',
  fileFormat: (formats) =>
    `Нельзя загружать файлы формата${formats}. Доступные форматы для загрузки: pdf, jpeg, png`,
  passportSeriesAndNumber: 'Введите корректные серию и номер паспорта',
  requiredDocument: 'Загрузите документы',
  formRequired: 'Введите данные',
  accept: 'Обязательно подтвердите соглашение с условиями',
  acceptEng: 'Please confirm your consent to the terms of data processing',
  zipCode: 'Введите 6 цифр почтового индекса',
  carChassisNumber: 'Введите от 4 до 6 цифр шасси',
  carBodyNumber: 'Введите от 9 до 12 символов номера кузова',
  osagoSeries: 'Введите кириллицей серию полиса ОСАГО',
  osagoNumber: 'Введите номер полиса ОСАГО',
  driverLicense: 'Введите серию и номер ВУ',
  passportSeries: 'Введите серию паспорта',
  passportNumber: 'Введите номер паспорта',
  drivingLicenceSer: 'Введите серию водительского удостоверения',
  drivingLicenceNumber: 'Введите номер водительского удостоверения',
  enginePower: 'Введите мощьность двигателя в л.с.',
  registrationPlate: 'Введите государственный номер',
  vinCode: 'Введите значение VIN',
  bodyNumber: 'Введите номер кузова',
  number: 'Введите число',
  numberCountRequests: 'Введите число от 1 до 998',
  maxDate: 'Некорректная дата. Дата не может быть позже текущей',
}
